module.exports = __webpack_public_path__ + "static/media/Ts_Cs_DCM.0fcaee6f.pdf";